import { useState } from "react";
import { Box, Typography } from "@mui/material"
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import BaseColorText from "../../BaseColorText";
import BaseButton from "../../BaseButton";
import BaseInput from "../../BaseInput";
import BaseSelect from "../../BaseSelect";
import BaseTextareaAutosize from "../../BaseTextareaAutosize";
import HelpText from "../../HelpText";
import { TITLE_OPTIONS } from "../../../constants";

/**
 * @param {Object} props
 */
const UserSubjectForm = ({ infoFormStates, setInfoFormStates, kitCode = 'DDDDDD', onNextStep }) => {
  const [formStates, setFormStates] = useState({
    title: '',
    specify: '',
    bio: '',
  })

  const handleChangeSelect = (value, name) => {
    setFormStates({
      [name]: value
    })
  }

  const handleChangeInput = (e) => {
    setFormStates({
      kitCode,
      ...formStates,
      [e.target.name]: e.target.value
    })
  }

  const handleClickSubmit = () => {
    if (formStates.title) {
      setInfoFormStates({
        ...infoFormStates,
        ...formStates
      })
      onNextStep()
    }
  }

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%'
    }}>
      <Box sx={{
        width: '100%',
        mt: '70px'
      }}>
        <Typography variant="h1">
          More <BaseColorText isGradient gradientColor='#5A3BC7 30%, #5FB2EC 90%'>about you.</BaseColorText>
        </Typography>
        <Typography 
          variant="h4"
          sx={{
            color: '#46545F',
            mt: '20px'
          }}
        >
          This tool is strictly for dDNA Physicians and Administrators only.
        </Typography>
        <Box sx={{
          mt: '30px',
        }}>
          <BaseSelect
            label='Title'
            name='title'
            value={formStates.title}
            options={TITLE_OPTIONS}
            onChangeSelect={handleChangeSelect}
            required
          />
          <BaseInput
            sx={{
              mt: '16px',
            }}
            fullWidth
            label='Your Specialty'
            name='specialty'
            type='text'
            placeholder='Specialty'
            value={formStates.specialty || ''}
            onChange={handleChangeInput}
          />
          <BaseTextareaAutosize 
            sx={{
              mt: '16px',
            }}
            fullWidth
            label='Bio'
            name='bio'
            id='bio'
            placeholder='Bio'
            maxLength={300}
            value={formStates.bio || ''}
            onChange={handleChangeInput}
          />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: { xs: '30px', sm: '50px' },
            }}
          >
            <BaseButton
              disabled={formStates?.title.length === 0}
              variant='contained'
              buttonType='primary'
              type='button'
              onClick={handleClickSubmit}
            >
              <Typography variant="body">
                Sign Up
              </Typography>
              <ChevronRightIcon/>
            </BaseButton>
          </Box>
        </Box>
      </Box>
      <HelpText sx={{
        width: '100%',
        borderTop: '1px solid #ABB7C0',
        textAlign: 'center',
        pt: '33px',
        pb: { xs: 0, md: '30px' },
        mt: '80px'
      }} />
    </Box>
  )
}

export default UserSubjectForm;